
import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "Booking";
const API_URL = "parking-booking"

// get all with pagination
export const GetAll = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

// get item data with id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create item ** // Updated Api Error Handle Method
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Create ${ItemName} API error:`, error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// update item ** // Updated Api Error Handle Method
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete item
export const Delete = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// Get Booking Number
export const GetAllBookingNumber = async () => {
  try {
    const result = await getData(`/${API_URL}/booking-number/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Booking Number data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// Get Vehicle Type
export const GetAllVehicleType = async () => {
  try {
    const result = await getData(`/${API_URL}/vehicle/all`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Booking Number data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get zone type 
export const GetZoneTypeById = async (id) => {
  if (!id) {
    return { data: { success: true, data: [] } };
  }

  try {

    const result = await getData(`/${API_URL}/zone/all/${id}`);

    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Zone Type API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get zone type 
export const GetSlotTypeById = async ({ zone_list_id, check_in, check_out }) => {
  if (!zone_list_id) {
    return { data: { success: true, data: [] } };
  }
  try {
    const result = await postData(`/${API_URL}/slot/all/${zone_list_id}`, { check_in, check_out });
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Slot Type API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get zone type 
export const GetSettingById = async (id) => {
  if (!id) {
    return { data: { success: true, data: [] } };
  }
  try {
    const result = await getData(`/${API_URL}/setting/all/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Setting API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get zone type 
export const GetSlotTimeById = async ({ zone_id, vehicle_id }) => {
  if (!zone_id || !vehicle_id) {
    return { data: { success: true, data: [] } };
  }

  try {
    const result = await getData(
      `/${API_URL}/setting/all/${zone_id}/${vehicle_id}`
    );
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Slot Time API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};